import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import Lines from '../components/common/Lines';
import ProgressScroll from '../components/common/ProgressScroll';
import Cursor from '../components/common/cusor';
import LoadingScreen from '../components/common/loader';
import Footer from '../components/common/Footer';
import Navbar from '../components/common/Navbar';
import PageHero from '../components/common/PageHero';
import './legal.css';

export default function PrivacyPolicy() {
  const main = useRef();
  const sections = [
    {
      title: 'Information We Collect',
      paragraphs: ['We may collect the following information:'],
      bullets: [
        {
          label: 'Contact Information',
          text: 'name, email address, phone number, and social media handles.',
        },
        {
          label: 'Professional Details',
          text: 'creator or brand name, links, demographic preferences, and engagement data.',
        },
        {
          label: 'Usage Data',
          text: 'cookies, IP addresses, and analytics to improve user experience.',
        },
      ],
    },
    {
      title: 'How We Use Your Information',
      paragraphs: ['We use your information to support and improve your experience with Profile Management LLC:'],
      bullets: [
        {
          label: 'Communication Management',
          text: 'coordinate campaigns and creator or brand opportunities.',
        },
        {
          label: 'Relevant Messaging',
          text: 'deliver updates, offers, and news from Profile Management LLC.',
        },
        {
          label: 'Service Enhancements',
          text: 'refine our services and personalize your journey with us.',
        },
      ],
    },
    {
      title: 'Consent to Communications',
      paragraphs: ['By submitting your information, you consent to receive text and email updates from Profile Management LLC.'],
      bullets: [
        {
          label: 'SMS Messages',
          text: 'sent via Textedly. Standard message and data rates may apply.',
        },
        {
          label: 'Opt-Out',
          text: 'reply STOP at any time to unsubscribe from SMS updates.',
        },
        {
          label: 'Emails',
          text: 'click “unsubscribe” at the bottom of any message to stop receiving updates.',
        },
      ],
    },
    {
      title: 'Sharing of Information',
      paragraphs: [
        'We do not sell your personal data. Information is shared only with trusted service providers or partners that assist our business operations, such as communications or analytics tools. All partners must adhere to strict data-protection standards.',
      ],
    },
    {
      title: 'Data Retention',
      paragraphs: [
        'We retain personal data only as long as necessary to fulfill the purposes outlined in this policy or as required by law.',
      ],
    },
    {
      title: 'Security',
      paragraphs: [
        'We use reasonable administrative, technical, and physical measures to protect your data from unauthorized access or disclosure.',
      ],
    },
    {
      title: 'Your Rights',
      paragraphs: [
        'You may request to access, correct, or delete your personal information at any time. We will respond promptly to support your request.',
      ],
    },
    {
      title: 'Policy Updates',
      paragraphs: [
        'We may revise this Privacy Policy periodically. Updates are posted on this page with a new effective date, so please check back to stay informed.',
      ],
    },
    {
      title: 'Contact Us',
      highlight: true,
      paragraphs: ['For any privacy inquiries, connect with our team using the details below:'],
      contact: true,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Privacy Policy | Profile Management LLC</title>
        <link rel="icon" href="/assets/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/assets/imgs/favicon.ico" />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
        <script src="/assets/js/gsap.min.js" defer />
        <script src="/assets/js/ScrollTrigger.min.js" defer />
        <script src="/assets/js/ScrollSmoother.min.js" defer />
        <script src="/assets/js/splitting.min.js" defer />
        <script src="/assets/js/isotope.pkgd.min.js" defer />
        <script src="/assets/js/plugins.js" defer />
        <script src="/assets/js/TweenMax.min.js" defer />
        <script src="/assets/js/charming.min.js" defer />
        <script src="/assets/js/countdown.js" defer />
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <Navbar />
        <div id="smooth-wrapper" ref={main}>
          <div id="smooth-content">
            <main className="main-bg o-hidden">
              <PageHero
                title="Privacy"
                accent="Policy"
                subtitle="Our Commitment"
                description="We respect your data, your voice, and your trust. Explore how Profile Management LLC collects, uses, and protects your information across every touchpoint."
              />
              <section className="legal-content">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-9">
                      {sections.map((section, index) => (
                        <div
                          key={section.title}
                          className={`legal-card${section.highlight ? ' highlight' : ''}`}
                        >
                          <span className="legal-step">{String(index + 1).padStart(2, '0')}</span>
                          <h3>{section.title}</h3>
                          {section.paragraphs?.map((paragraph) => (
                            <p key={paragraph}>{paragraph}</p>
                          ))}
                          {section.bullets ? (
                            <ul className="legal-bullets">
                              {section.bullets.map((bullet) => (
                                <li key={bullet.label}>
                                  <span className="legal-bullet-label">{bullet.label}:</span> {bullet.text}
                                </li>
                              ))}
                            </ul>
                          ) : null}
                          {section.contact ? (
                            <div className="legal-contact mt-20">
                              <p>
                                Email: <a href="mailto:accounts@profilemgmt.co">accounts@profilemgmt.co</a>
                              </p>
                              <p>Profile Management LLC — Florida, USA</p>
                            </div>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}


